import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const updateAppAdminTrainingTopicSlice = createApi(`UpdateAppAdminTrainingTopicSlice`, "PUT");

const UpdateAppAdminTrainingTopicSlice = createSlice({
  name: 'UpdateAppAdminTrainingTopicSlice',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateAppAdminTrainingTopicSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateAppAdminTrainingTopicSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateAppAdminTrainingTopicSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default UpdateAppAdminTrainingTopicSlice.reducer;
